import { createAction, props } from '@ngrx/store';
import { Document } from '../../models/document';
import { ExportFormatEnum } from '../../enum/export-format.enum';
import { ExportProviderEnum } from '../../enum/export-provider.enum';
import { RouteData } from '../../models/route-data';
import { SearchResult } from '../../models/search-result';

export const interfaceShipmentViewChanged = createAction(
    '[Shipment Table] Current View has Changed',
    props<{ id: string | null }>()
);

export const interfaceShipmentViewSelect = createAction(
    '[Shipment Table] User Selected View',
    props<{ id: string }>()
);

export const interfaceShipmentViewSave = createAction(
  '[Shipment Table] User Save View',
  props<{ name: string }>()
);

export const interfaceDocumentClear = createAction(
    '[Interface] Document State Cleared'
);

export const interfaceDocumentProcessing = createAction(
    '[Interface] Document Preparation in Progress'
);

export const interfaceDocumentReady = createAction(
    '[Interface] Document Preparation Complete',
    props<{ document: Document | null }>()
);

export const interfaceSetExports = createAction(
    '[Interface] Set Export Availability',
    props<{ formats: ExportFormatEnum[], provider: ExportProviderEnum }>()
);

export const interfaceClearExports = createAction(
    '[Interface] Clear Export Availability'
);

export const interfaceExport = createAction(
    '[Interface] Start Export',
    props<{ format: ExportFormatEnum }>()
);

export const interfaceExportStart = createAction(
    '[Interface] Export In Progress'
);

export const interfaceExportComplete = createAction(
    '[Interface] Export Completed Successfully'
);

export const interfaceExportError = createAction(
    '[Interface] Export Failed'
);

export const interfaceExportProgress = createAction(
    '[Interface] Export Progress',
    props<{ progress: number }>()
);

export const interfaceSetRouteData = createAction(
    '[Interface] Set Route Data from Router',
    props<{ routeData: RouteData }>()
);

export const interfaceSetSearchTerm = createAction(
    '[Interface] Set Search Term',
    props<{ term: string }>()
);

export const interfaceSetSearchResults = createAction(
    '[Interface] Set Search Results',
    props<{ results: SearchResult[] }>()
);
